export const infoWrapperHorizontalMargin = '10px';
export const infoWrapperVerticalMargin = '18px';
